import { render } from "./Referral.vue?vue&type=template&id=527ea061"
import script from "./Referral.vue?vue&type=script&lang=js"
export * from "./Referral.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alvinpascasio/pjf-wine-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__